import BASEURLGESTTOR from '../api/gesttor'
import { payloadAtualizarProcessoSeletivo, payloadCriarProcessoSeletivo, payloadProcessoInscritos, payloadProcessoEtapa, payloadAtualizarSituacaoProcessoSeletivo, payloadCriarProcessoNps, payloadAtualizarProcessoNps, payloadReprovarInscrito, payloadAtualizarProcessoParaRepescagem } from '../../interfaces/processoSeletivo'


export function listarProcessoSeletivo () {
    return BASEURLGESTTOR.get(`/listarProcessoSeletivo`)
}

export function listarProcessoSeletivoPorId (idProcessoSeletivo:string) {
    return BASEURLGESTTOR.get(`/listarProcessoSeletivo/${idProcessoSeletivo}`)
}

export function criarProcessoSeletivo (payload: payloadCriarProcessoSeletivo) {
    return BASEURLGESTTOR.post(`/processoSeletivo`, payload)
}

export function atualizarProcessoSeletivo (payload: payloadAtualizarProcessoSeletivo, idProcessoSeletivo: string) {
    return BASEURLGESTTOR.patch(`/atualizarProcessoSeletivo/${idProcessoSeletivo}`, payload)
}

export function finalizarProcessoSeletivo (payload: payloadAtualizarSituacaoProcessoSeletivo, idProcessoSeletivo: string) {
    return BASEURLGESTTOR.put(`/finalizarProcessoSeletivo/${idProcessoSeletivo}`, payload)
}

export function atualizarProcessoInscrito (payload: payloadProcessoInscritos, idProcessoInscrito: string) {
    return BASEURLGESTTOR.patch(`/processoInscrito/${idProcessoInscrito}`, payload)
}

export function desclassificarCandidato(idProcessoInscrito: string, idProcessoSeletivo: string, payload: payloadReprovarInscrito) {
    return BASEURLGESTTOR.patch(`/processoInscrito/${idProcessoInscrito}/${idProcessoSeletivo}`, payload)
}

export function criarProcessoEtapas (payload: payloadProcessoEtapa, idProcessoSeletivo: string) {
    return BASEURLGESTTOR.post(`/processoEtapas/${idProcessoSeletivo}`, payload)
}

export function deletarEtapa (idEtapa: string) {
    return BASEURLGESTTOR.delete(`/processoEtapas/${idEtapa}`)
}

export function criarProcessoNps (payload: payloadCriarProcessoNps, idProcessoSeletivo: string) {
    return BASEURLGESTTOR.post(`/processoNps/${idProcessoSeletivo}`, payload)
}

export function atualizarProcessoNps (payload: payloadAtualizarProcessoNps, idProcessoNps: string) {
    return BASEURLGESTTOR.patch(`/processoNps/${idProcessoNps}`, payload)
}

export function abrirRepescagem(payload: payloadAtualizarProcessoParaRepescagem, idProcessoSeletivo: string) {
    return BASEURLGESTTOR.patch(`/criarRepescagem/${idProcessoSeletivo}`, payload)
}